import { useState, useEffect } from 'react';
import { AVATARS, AvatarType, DEFAULT_AVATAR } from '../constants/avatars';

export const useAvatar = () => {
  const [selectedAvatar, setSelectedAvatar] = useState<AvatarType>(() => {
    const saved = localStorage.getItem('calmi_avatar');
    return (saved as AvatarType) || DEFAULT_AVATAR;
  });

  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'calmi_avatar') {
        setSelectedAvatar((e.newValue as AvatarType) || DEFAULT_AVATAR);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const handleAvatarSelect = (avatar: AvatarType) => {
    setSelectedAvatar(avatar);
    localStorage.setItem('calmi_avatar', avatar);
    window.dispatchEvent(new CustomEvent('calmi-avatar-change', { detail: avatar }));
  };

  const selectedAvatarData = AVATARS.find(a => a.id === selectedAvatar) || AVATARS[0];

  return {
    selectedAvatar,
    setSelectedAvatar: handleAvatarSelect,
    selectedAvatarData
  };
};
